/**
 * Capitalizes the first letter of every word - "field officer" becomes
 * "Field Officer". Words split on whitespace; the rest of each word is
 * lowercased, so the result does not depend on the input's casing.
 */
export function titleCase(value: string): string {
  return value
    .split(" ")
    .map((word) => (word.length === 0 ? word : word[0].toUpperCase() + word.slice(1).toLowerCase()))
    .join(" ");
}
